import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLoginHelper } from '../../helpers/login/loginHelper';
import { useGlobalState } from '../../state/GlobalStateProvider';

const ProtectedRoute = ({ children }) => {
  const [{ user }] = useGlobalState();
  const { openLogin } = useLoginHelper();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      openLogin();
    }
  }, [user]);

  if (!user) return <></>;
  return children;
};

export default ProtectedRoute;
